import type { OS } from '@/components/VerificationEnv/types'
export const DEFAULT_OS: OS = {
  type: 'os',
  name: 'macOS',
  family: 'Big Sur',
  version: '11.2.1'
}
